<!-- <app-widget-yulava *ngIf="widgetYulava"></app-widget-yulava> -->
<app-widget-banners *ngIf="widgetBanners"></app-widget-banners>
<app-widget-news *ngIf="widgetNews"></app-widget-news>
<app-widget-matches *ngIf="matchesNews"></app-widget-matches>




